export const triggerBasketEvent = () => {
  window.gtag("event", "userRegisterSuccess");
};

export const triggerConversionEvent = () => {
  window.gtag("event", "userDepositSuccess");
};
